var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEngineering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1735_719)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1735_719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25123 6.96026L4.40579 6.65512C4.52466 6.64426 4.6345 6.58208 4.68733 6.47776L5.74544 4.37821C5.50956 4.33474 5.29853 4.22798 5.13351 4.07812L4.05989 6.20826C4.00624 6.31402 4.02605 6.42991 4.09238 6.51971L3.9375 6.82552L4.25123 6.96026Z",
    fill: "url(#paint0_linear_1735_719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98263 4.08158C6.45981 4.08158 6.84807 3.72418 6.84807 3.28493C6.84807 2.84568 6.45981 2.48828 5.98263 2.48828C5.50545 2.48828 5.11719 2.84568 5.11719 3.28493C5.11719 3.72418 5.50545 4.08158 5.98263 4.08158ZM5.80954 3.1256H6.15572V3.44426H5.80954V3.1256Z",
    fill: "url(#paint1_linear_1735_719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90438 6.20833L6.83064 4.07812C6.66561 4.22795 6.45459 4.33467 6.21875 4.37811L7.27693 6.47767C7.32984 6.58219 7.4396 6.64418 7.55846 6.65499L7.71304 6.96017L8.02676 6.82542L7.87195 6.51975C7.93863 6.42936 7.95749 6.3129 7.90438 6.20833Z",
    fill: "url(#paint2_linear_1735_719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50338 2.2813V1.99947C6.50338 1.7359 6.27044 1.52148 5.98411 1.52148C5.69777 1.52148 5.46484 1.7359 5.46484 1.99947V2.2813C5.62285 2.21167 5.79758 2.16943 5.98411 2.16943C6.17064 2.16943 6.34537 2.21167 6.50338 2.2813Z",
    fill: "url(#paint3_linear_1735_719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79688 5.23828L7.99323 5.62591C8.40541 5.75992 8.5905 5.91155 8.5905 6.00404C8.5905 6.075 8.49398 6.16742 8.33239 6.25128L8.50243 6.52886C8.86129 6.34278 8.93668 6.14081 8.93668 6.00404C8.93668 5.59802 8.32756 5.36532 7.79688 5.23828Z",
    fill: "url(#paint4_linear_1735_719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78886 5.05499L5.625 5.37847C5.86317 5.36951 6.10169 5.36986 6.33968 5.37884L6.17532 5.05435C6.04589 5.0518 5.91834 5.05246 5.78886 5.05499Z",
    fill: "url(#paint5_linear_1735_719)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84475 8.56767L5.7915 8.50697C5.67679 8.52209 5.5612 8.53234 5.44556 8.53769L5.05996 9.20676C5.00469 9.30267 4.889 9.35524 4.77266 9.3373L4.19384 9.24802C4.07754 9.23008 3.98677 9.14565 3.96847 9.03842L3.84059 8.2887C3.73365 8.2491 3.62849 8.20494 3.52589 8.15661L2.8271 8.55934C2.72711 8.61696 2.59839 8.6092 2.5074 8.54014L2.05464 8.19642C1.96367 8.12736 1.93091 8.01246 1.97332 7.91116L2.26924 7.20445C2.19777 7.12054 2.13036 7.03345 2.06753 6.94378L1.24519 6.97097C1.12733 6.97488 1.01999 6.90892 0.978711 6.80722L0.773292 6.30113C0.732021 6.19945 0.766057 6.08487 0.857816 6.01666L1.49806 5.5407C1.48165 5.43512 1.4705 5.32872 1.4647 5.22226L0.737852 4.8673C0.633662 4.81645 0.576534 4.7099 0.596039 4.60285L0.693032 4.07005C0.712503 3.96301 0.804207 3.87944 0.920731 3.86258L1.7352 3.74486C1.77821 3.64646 1.82616 3.54964 1.87867 3.45512L1.4412 2.81195C1.3786 2.71994 1.38699 2.6014 1.46203 2.51765L1.83544 2.10086C1.91046 2.01714 2.03527 1.98695 2.14534 2.026L2.91308 2.29839C3.00413 2.23266 3.0987 2.17063 3.19611 2.11272L3.19115 1.9851C3.28363 2.37174 3.39886 2.78893 3.53538 3.22865C3.49579 3.26033 3.4572 3.29311 3.41967 3.32696L3.61289 3.47363C3.70523 3.76013 3.80618 4.05525 3.91534 4.35688L3.07113 3.71601C2.67217 4.27221 2.52669 4.97307 2.71774 5.65154L4.10985 5.17275C4.09766 5.07794 4.09969 4.98332 4.11478 4.89119C4.18016 5.06122 4.24797 5.23286 4.31815 5.40574C4.37946 5.55681 4.44147 5.70607 4.50401 5.85332C4.42775 5.79321 4.35947 5.72351 4.30162 5.64522L2.90952 6.12401C3.24858 6.75155 3.85767 7.1929 4.55509 7.37201L4.73516 6.38291C4.86737 6.67776 5.00123 6.96287 5.13553 7.2364L5.09548 7.45649C5.14627 7.45939 5.19688 7.46091 5.24726 7.4611C5.44753 7.85876 5.64802 8.22963 5.84475 8.56767Z",
    fill: "url(#paint6_linear_1735_719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85623 1.74166L4.6646 1.77309C3.88462 1.16638 3.67638 1.50847 3.66976 1.75535C3.59124 4.86817 5.26603 7.20508 6.11325 7.98443C6.89849 8.52907 7.06005 7.72481 7.04267 7.2546L7.24088 7.14556C7.39264 9.00179 6.57235 8.98512 6.14323 8.74476C3.5502 7.21517 2.21798 2.46651 3.1803 1.34866C3.84405 0.733355 4.57415 1.35428 4.85623 1.74166Z",
    fill: "#E00000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1735_719",
    x1: 5.74544,
    y1: 5.51919,
    x2: 3.9375,
    y2: 5.51919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1735_719",
    x1: 6.84807,
    y1: 3.28493,
    x2: 5.11719,
    y2: 3.28493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1735_719",
    x1: 8.02676,
    y1: 5.51915,
    x2: 6.21875,
    y2: 5.51915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1735_719",
    x1: 6.50338,
    y1: 1.90139,
    x2: 5.46484,
    y2: 1.90139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1735_719",
    x1: 8.93668,
    y1: 5.88357,
    x2: 7.79687,
    y2: 5.88357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1735_719",
    x1: 6.33968,
    y1: 5.21579,
    x2: 5.625,
    y2: 5.21579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1735_719",
    x1: 4.53493,
    y1: 5.29575,
    x2: 0.955006,
    y2: 6.74882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1735_719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.07172,
    height: 9.07172,
    fill: "white",
    transform: "translate(0.210938 0.580078)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1735_719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.90809,
    height: 5.43846,
    fill: "white",
    transform: "translate(4.47656 1.52344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEngineering);
export default __webpack_public_path__ + "static/media/icon-engineering.6b3d15af82fe9044aeb86c8271a29f21.svg";
export { ForwardRef as ReactComponent };